import CabinetsChartComponent from "../cabinets/cabinet-chart.component";
import React from "react";

const CustomCabinetsChartComponent: React.FC<any> = (props: {
  props: { cabinetTemperature: { [x: string]: any; }; zonesTemperature: { [x: string]: any; }; alertsList: any[]; };
  timezone: any;
  cabinetType: any;
  dateFormat: any;
}) => {
  const getOnlyTemperatureAlerts = (alerts: any[]) => {
    if (!alerts) return [];
    const tempOnlyAlerts = alerts.filter(
      (alert: any) => alert.alertType.alertGroup === "TEMPERATURE"
    );

    // Group by deviceId for displaying multiple devices
    const groupedAlerts = tempOnlyAlerts.reduce(
      (previous: any, current: any) => {
        previous[`${current.deviceId}`] = [
          ...(previous[`${current.deviceId}`] || []),
          current,
        ];
        return previous;
      },
      {}
    );

    return groupedAlerts;
  };

  const separateCabinetsAndZones = (allCabinets: any) => {
    const zones: Record<string, Record<string, any[]>> = {};
    const cabinets: Record<string, any[]> = {};

    Object.keys(allCabinets).forEach((deviceId) => {
      allCabinets[deviceId].forEach((entry: any) => {
        if (entry.zoneId) {
          // Group by zoneId and deviceId
          if (!zones[entry.zoneId]) {
            zones[entry.zoneId] = {};
          }
          if (!zones[entry.zoneId][deviceId]) {
            zones[entry.zoneId][deviceId] = [];
          }
          zones[entry.zoneId][deviceId].push(entry);
        } else {
          // Group cabinets by deviceId
          if (!cabinets[deviceId]) {
            cabinets[deviceId] = [];
          }
          cabinets[deviceId].push(entry);
        }
      });
    });

    return { zones, cabinets };
  };

  const { zones, cabinets } = separateCabinetsAndZones(
    props.props.cabinetTemperature
  );

  return (
    <div>
      {/* Render charts for zones */}
      {Object.keys(zones).map((zoneId, index) => (
        <div key={zoneId}>
          { props.props.zonesTemperature[zoneId] != undefined && (
            <CabinetsChartComponent
              data={{
                temp: zones[zoneId],
                zoneAverages: props.props.zonesTemperature[zoneId],
              }}
              dateFormat={props.dateFormat}
              cabinetType={props.cabinetType}
              timezone={props.timezone}
              deviceId={zoneId}
              customOptions={true}
            />
          )}
          <br />
        </div>
      ))}

      {/* Render charts for cabinets (not part of zones) */}
      {Object.keys(cabinets).map((deviceId) => (
        <div key={deviceId}>
          <CabinetsChartComponent
            data={{
              temp: props.props.cabinetTemperature[deviceId],
              alerts:
                getOnlyTemperatureAlerts(props.props.alertsList)[deviceId] ||
                [],
            }}
            dateFormat={props.dateFormat}
            cabinetType={props.cabinetType}
            timezone={props.timezone}
            deviceId={deviceId}
          />
          <br />
        </div>
      ))}
    </div>
  );
};

export default CustomCabinetsChartComponent;
